import moment from 'moment';

// eslint-disable-next-line consistent-return,import/prefer-default-export
export const formataDataHoraEnGB = (data) => moment(data, 'DD/MM/YYYY HH:mm', true).format('YYYY-MM-DD HH:mm');

export const formataDataHoraPtBR = (data) => moment(data).format('DD/MM/YYYY HH:mm');

export default {
  formataDataHoraEnGB,
  formataDataHoraPtBR,
};
